var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUrl = function SvgUrl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.778-6.306 14.084-14.083 14.084C6.6 33.453.295 27.143.295 19.365.295 11.586 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.762 18.765h2.548a10.162 10.162 0 0 1 1.706-4.885 5.655 5.655 0 0 0-4.254 4.885Zm5.618-4.722a8.963 8.963 0 0 0-1.866 4.722h3.733a8.963 8.963 0 0 0-1.867-4.722Zm1.867 5.922a8.963 8.963 0 0 1-1.867 4.721 8.963 8.963 0 0 1-1.866-4.721h3.733Zm-4.937 0H8.762a5.655 5.655 0 0 0 4.254 4.884 10.162 10.162 0 0 1-1.706-4.884Zm4.435 4.884a10.163 10.163 0 0 0 1.706-4.884h2.548a5.655 5.655 0 0 1-4.254 4.884Zm4.254-6.084H17.45a10.163 10.163 0 0 0-1.706-4.885 5.654 5.654 0 0 1 4.254 4.885Zm-12.469.6a6.85 6.85 0 1 1 13.7 0 6.85 6.85 0 0 1-13.7 0Z",
    fill: "#0086C9"
  })));
};

export default SvgUrl;